import { schema } from "normalizr";
import { Order } from "./order";

export const Orders = new schema.Array(Order);
